import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7102285a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6 p-9" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Usuarios", -1))
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_6 = {
  type: "button",
  class: "btn btn-melon",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_customer"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = { class: "flex justify-content-end" }
const _hoisted_10 = { class: "p-input-icon-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ExportCustomerModal = _resolveComponent("ExportCustomerModal")!
  const _component_AddCustomerModal = _resolveComponent("AddCustomerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportExcel && _ctx.exportExcel(...args))),
              type: "button",
              class: "btn btn-melon-secundario me-3"
            }, " Exportar "),
            _createElementVNode("button", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Plus.svg" })
              ]),
              _createTextVNode(" Nuevo Usuario ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DataTable, {
          value: _ctx.allUsuarios,
          paginator: true,
          rows: 10,
          showGridlines: "",
          dataKey: "tokenUsuario",
          rowHover: true,
          selection: _ctx.selectedUsuarios,
          "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUsuarios) = $event)),
          filters: _ctx.filters1,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters1) = $event)),
          loading: _ctx.loading,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: [10, 25, 50],
          currentPageReportTemplate: "Mostrando {first} a {last} de {totalRecords} registros",
          globalFilterFields: [
          'rutProveedor',
          'contactoEmail',
          'contactoNombre',
          'contactoTelefono',
        ],
          responsiveLayout: "scroll"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.filters1['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters1['global'].value) = $event)),
                  class: "form-control w-250px ps-14",
                  placeholder: "Buscar"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(" No existen usuarios. ")
          ]),
          loading: _withCtx(() => [
            _createTextVNode(" Cargando usuarios. Por favor espere. ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              selectionMode: "multiple",
              style: {"width":"3rem"},
              exportable: false
            }),
            _createVNode(_component_Column, {
              field: "rutProveedor",
              header: "Rut Proveedor",
              sortable: "",
              style: {"min-width":"9rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.rutProveedor), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by name"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "email",
              header: "Email",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.email), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "nombreCompleto",
              header: "Nombre Contacto",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.nombreCompleto), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "telefono",
              header: "Teléfono Contacto",
              sortable: "",
              filterMatchMode: "contains",
              style: {"min-width":"14rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.telefono), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "Search by country"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "fechaCreacion",
              header: "F. Creación",
              sortable: "",
              dataType: "date",
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaCreacion)), 1)
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_Calendar, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  dateFormat: "mm/dd/yy",
                  placeholder: "mm/dd/yyyy"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "activo",
              header: "Estado",
              sortable: "",
              dataType: "date",
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["image-text", 'customer-badge status-' + data.activo])
                }, _toDisplayString(data.activo ? "Vigente" : "No Vigente"), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              exportable: false,
              style: {"min-width":"8rem"}
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  class: "p-button-rounded p-button-success mr-2",
                  onClick: ($event: any) => (_ctx.editUsuario(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "selection", "filters", "loading"])
      ])
    ]),
    _createVNode(_component_ExportCustomerModal),
    _createVNode(_component_AddCustomerModal)
  ], 64))
}